export default [
  {
    path: '/apps/pic-regra/list',
    name: 'apps-pic-regra-list',
    component: () => import('@/views/cadastros/apoio-vendas/pic-regra/list/Index.vue'),
    meta: {
      pageTitle: 'Pic Regra',
    },
  },
  // {
  //     path: '/apps/pic-regra/edit/:id',
  //     name: 'apps-pic-regra-edit',
  //     component: () => import('@/views/cadastros/apoio-vendas/pic-regra/pic-regra-edit/Pic RegraEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Pic Regra',
  //     },
  // },
];
